import { useDispatch } from 'react-redux'
import { clearErrorAuth } from 'presentation/redux/slices/authUserSlice'

export const useClearErrorAuth = () => {
  const dispatch = useDispatch()
  const clearError = () => {
    dispatch(clearErrorAuth())
  }

  return { clearError }
}
